<template>
	<div class="page">
		<!-- chart -->
		<v-chart
			type="bar"
			trim-labels
			no-markers
			:show-data-labels="false"
			show-tooltip
			:labels="conceptsLabels"
			:series="conceptsViewsData"
			:height="300"
			:rotate-labels="-90"
			:options="{
				yaxis: {
					min: 0,
					max: 4,
					labels: {
						formatter: val => ['NI', 'F', 'G', 'VG', 'Ex'][val] || '',
						style: { fontSize: '12px' }
					}
				}
			}"
			:tooltip-formatter="(val) => ['ضعيف جداً', 'ضعيف', 'جيد', 'جيد جداً', 'ممتاز'][val] || ''"
			class="mb-n5"
		/>

		<!-- concepts -->
		<v-row dense>
			<v-col
				v-for="(concept, index) in concepts"
				:key="index"
				sm="6"
				cols="6"
			>
				<v-card
					class="language-concept-card"
					:to="{
						name: 'language-concept',
						params: { subjectId: $route.params.subjectId, conceptId: concept.id }
					}"
				>
					<v-card-text class="d-flex justify-space-between align-center ps-3 pe-2 py-1">
						<v-card
							width="40"
							height="40"
							class="concept-number text-center primary--text"
						>
							{{index + 1}}
						</v-card>
						<div class="d-flex flex-column">
							<span class="text-h6 font-weight-regular primary--text">{{ concept.name }}</span>
							<span :class="concept.mark > 50 ? 'success--text' : 'error--text'">
								{{concept.mark}}%
							</span>
						</div>
						<v-icon>mdi-chevron-left</v-icon>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<div v-if="!concepts.length" class="text-center mt-13">
			لا يوجد 
		</div>
	</div>
</template>

<script>
import VChart from '@/components/VChart.vue'
export default {
	name: 'Language',
	components: { VChart },
	data() {
		return {
			concepts: [],
			conceptsLabels: [],
			conceptsViewsData: [],
		}
	},
	
	created() {
		this.$eventBus.$emit('page-loader', true);
		this.$store.dispatch('languages/fetchStatistics').then(data => {
			this.concepts = data;
			this.conceptsLabels = data.map(c => c.name);
			this.conceptsViewsData = [{
				name: 'mark',
				data: data.map(c => {
					const index = ['Need Improved', 'Failed', 'Good', 'Very Good', 'Excellent'].indexOf(c.symbolicMark);
					return index !== -1 ? index : 0;
				})
			}];
		}).finally(() => {
			this.$eventBus.$emit('page-loader', false);
		});
	}
}
</script>

<style lang="scss" scoped>
.language-concept-card {
	border-radius: 8px;
}
.concept-number {
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1.5rem;
	font-weight: 400;
	border-radius: 11px;
}
</style>